import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Sidebar from "./Components/Sidebar";
import Navbar from "./Components/Navbar";
import Header from "./Components/Header";
import Overview from "./Screens/Overview";
import Solar from "./Screens/Solar";
import Mains from "./Screens/Mains";
import Genset from "./Screens/Genset";
import Alerts from "./Screens/Alert";
import Excel from "./Screens/Excel";
import "./App.css";

// Create a separate component to access useLocation inside Router
const AppContent = () => {
  const location = useLocation();
  // const BaseUrl =
  //   window.location.hostname === "localhost"
  //     ? "http://localhost:5002/micro"
  //     : `http://${window.location.hostname}:5002/micro`;

  const BaseUrl = "http://13.126.205.156:5500/micro";
  // const BaseUrl = "http://13.126.205.156:5500/micro";

  return (
    <div className="flex h-screen custom-body">
      <Sidebar />
      <div className="flex flex-col flex-grow ml-12 transition-all duration-300">
        <Navbar />
        <Header />
        <div className="content flex-grow p-2 bg-gradient-to-r from-custom-green to-custom-dark">
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route
                path="/"
                element={
                  <AnimatedWrapper>
                    <Overview BaseUrl={BaseUrl} />
                  </AnimatedWrapper>
                }
              />
              <Route
                path="/solar"
                element={
                  <AnimatedWrapper>
                    <Solar BaseUrl={BaseUrl} />
                  </AnimatedWrapper>
                }
              />
              <Route
                path="/mains"
                element={
                  <AnimatedWrapper>
                    <Mains BaseUrl={BaseUrl} />
                  </AnimatedWrapper>
                }
              />
              <Route
                path="/genset"
                element={
                  <AnimatedWrapper>
                    <Genset BaseUrl={BaseUrl} />
                  </AnimatedWrapper>
                }
              />
              <Route
                path="/alerts"
                element={
                  <AnimatedWrapper>
                    <Alerts BaseUrl={BaseUrl} />
                  </AnimatedWrapper>
                }
              />
              <Route
                path="/excel"
                element={
                  <AnimatedWrapper>
                    <Excel BaseUrl={BaseUrl} />
                  </AnimatedWrapper>
                }
              />
            </Routes>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

// Animated wrapper component for page transitions
const AnimatedWrapper = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{
        type: "tween",
        ease: "easeInOut",
        duration: 0.5,
      }}
      className="w-full h-full"
      /*
      initial={{ y: 20, opacity: 0, scale: 0.98 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      exit={{ y: -20, opacity: 0, scale: 0.98 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        duration: 0.3,
      }}
      className="w-full h-full"
    */
    >
      {children}
    </motion.div>
  );
};

export default App;

/*
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './Components/Sidebar';
import Navbar from './Components/Navbar';
import Header from './Components/Header';
import Overview from './Screens/Overview';
import Solar from './Screens/Solar';
import Mains from './Screens/Mains';
import Genset from './Screens/Genset';
import Alerts from './Screens/Alert';
import Excel from './Screens/Excel';
import './App.css';

const App = () => {
  //const BaseUrl = "http://localhost:5002/micro"

  //console.log(window.location.hostname)

  const BaseUrl = window.location.hostname === "localhost"
    ? "http://localhost:5002/micro"
    : `http://${window.location.hostname}:5002/micro`;

  return (
    <Router>
      <div className="flex h-screen custom-body">
        <Sidebar />
        <div className="flex flex-col flex-grow ml-12 transition-all duration-300">
          <Navbar />
          <Header />
          <div className="content flex-grow p-2  bg-gradient-to-r from-custom-green to-custom-dark">
            <Routes>
              <Route path="/" element={<Overview BaseUrl={BaseUrl} />} />
              <Route path="/solar" element={<Solar BaseUrl={BaseUrl} />} />
              <Route path="/mains" element={<Mains BaseUrl={BaseUrl} />} />
              <Route path="/genset" element={<Genset BaseUrl={BaseUrl} />} />
              <Route path="/alerts" element={<Alerts BaseUrl={BaseUrl} />} />
              <Route path="/excel" element={<Excel BaseUrl={BaseUrl} />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default App;
*/
